import { UUID } from "@screencloud/uuid";
import { Space } from "../../types.g";

export const isNotCurrentSpace = (
  space: Pick<Space, "id">,
  currentSpaceId: UUID,
) => {
  return space.id !== currentSpaceId;
};
